import axios from 'axios';

let BASE_URL = process.env.REACT_APP_INT_URL;

const zirveNovaRequest = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

const loginZirveNova = async (username, password) => {
    return await zirveNovaRequest.post('/zirvenova-defter/login', { username, password });
};

const getReceiptListZirveNova = async (company_id, start_date, end_date, access_token) => {
    return await zirveNovaRequest.post('/zirvenova-defter/getReceiptList', { company_id, start_date, end_date, access_token });
};

const sendReceiptZirveNova = async (data) => {
    return await zirveNovaRequest.post('/zirvenova-defter/sendReceipt', data);
};

export { loginZirveNova, getReceiptListZirveNova, sendReceiptZirveNova };
